import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { HistoryResource } from 'services/api/resource';
import VideoCard from './VideoCard';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  height: 223px;
  overflow: auto;
  padding: 10px 0;
  .loading {
    display: flex;
    width: 100%;
    height: 40px;
    justify-content: center;
  }
`;
interface Props {
  list: HistoryResource[];
  loadMore: () => void;
  hasMore: boolean;
  loading: boolean;
}
const HistoryVideList = (props: Props) => {
  const { loadMore, list, loading, hasMore } = props;
  return (
    <Container
      onScroll={(e) => {
        if (loading || !hasMore) {
          return;
        }
        if (
          e.currentTarget.scrollTop + e.currentTarget.offsetHeight ===
          e.currentTarget.scrollHeight
        ) {
          loadMore();
        }
      }}
    >
      {list.map((x) => {
        const { textVideoContent, videoContent } = x;
        return <VideoCard item={videoContent || textVideoContent?.videoContent} />;
      })}
      {loading ? (
        <div className="loading">
          <LoadingOutlined />
        </div>
      ) : null}
    </Container>
  );
};

export default HistoryVideList;
